// import { ErrorHandler, ApiError, NetworkError } from './errorHandler.js';
import { ErrorHandler } from "../error_handling/errorHandler";
/**
 * Generic API client wrapper for consistent error handling
 */
class ApiClient {
  constructor() {
    this.baseURL = this.getV2EndPoint();//this.getEndPoint();
    this.token = this.getToken();
  }

  getEndPoint() {
    // return "/api/v2/index.php";
    // return "/api/index.php";
  }

  getV2EndPoint() {
    return "/api/v2/index.php";
  }

  getPaystackEndPoint() {
    return "/api/paystack_index.php";
  }

  getV2PaystackEndPoint() {
    return "/v2/paystack_index.php";
  }

  getPaystackEndPoint() {
    return "/api/paystack_index.php";
  }

  getToken() {
    return localStorage.getItem('token');
  }

  getHeaders(includeAuth = true) {
    const headers = {
      'Content-Type': 'application/json',
    };

    if (includeAuth && this.token) {
      headers['Authorization'] = `Bearer ${this.token}`;
    }

    return headers;
  }

  getBaseUrl(endpoint) {
    if (endpoint.includes(".php")) return endpoint;
    if (endpoint.includes("/v2")) return `${this.getV2EndPoint()}${endpoint}`;
    return `${this.baseURL}${endpoint}`;
  }

  async request(endpoint, options = {}) {
    const { includeAuth = true, ...fetchOptions } = options;

    try {
      const response = await fetch(this.getBaseUrl(endpoint), {
        ...fetchOptions,
        headers: {
          ...this.getHeaders(includeAuth),
          ...fetchOptions.headers,
        },
      });

      return await ErrorHandler.handleApiResponse(response);
    } catch (error) {
      ErrorHandler.logError(error, { endpoint, method: fetchOptions.method });
      throw ErrorHandler.handleNetworkError(error);
    }
  }

  async get(endpoint, options = {}) {
    return this.request(endpoint, { ...options, method: 'GET' });
  }

  async post(endpoint, data = null, options = {}) {
    return this.request(endpoint, {
      ...options,
      method: 'POST',
      body: data ? JSON.stringify(data) : undefined,
    });
  }

  async put(endpoint, data = null, options = {}) {
    return this.request(endpoint, {
      ...options,
      method: 'PUT',
      body: data ? JSON.stringify(data) : undefined,
    });
  }

  async delete(endpoint, options = {}) {
    return this.request(endpoint, { ...options, method: 'DELETE' });
  }

  getPaystackBaseUrl(endpoint) {
    if (endpoint.startsWith("/v2/")) return `${this.getV2PaystackEndPoint()}${endpoint}`;
    return `${this.getPaystackEndPoint()}${endpoint}`;
  }

  async paystackRequest(endpoint, options = {}) {
    try {
      const response = await fetch(this.getPaystackBaseUrl(endpoint), {
        ...options,
        headers: {
          ...this.getHeaders(options.includeAuth),
          ...options.headers,
        },
      });

      return await ErrorHandler.handleApiResponse(response);
    } catch (error) {
      ErrorHandler.logError(error, { endpoint, method: options.method, service: 'paystack' });
      throw ErrorHandler.handleNetworkError(error);
    }
  }
}

// Create singleton instance
const apiClient = new ApiClient();
// const apiClient = new ApiClient();

export default apiClient;